module.exports = "/_next/static/images/MC-38b248ea325072207c0ddd6fe7edec78.png";